import React from "react";
import PhotoPicker from "./PhotoPicker";
import { Overlay, Modal, Title, Field, ModalButtons, Button } from "./design";

const NewTaskModal = ({
    houses, form, setForm, saving, photoProcessing,
    onClose, onSave, onPhotos, onOpenCamera, onRemovePhoto, onPreview
}) => {
    const busy = saving || photoProcessing;
    const update = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

    return (
        <Overlay onClick={() => { if (!busy) onClose(); }}>
            <Modal role="dialog" aria-modal="true" aria-label="Neue Aufgabe" onClick={e => e.stopPropagation()}>
                <Title>Neue Aufgabe</Title>
                <form onSubmit={onSave}>
                    <Field>
                        <label htmlFor="todo-house">Haus</label>
                        <select id="todo-house" required value={form.house} onChange={e => update("house", e.target.value)}>
                            <option value="">Haus wählen</option>
                            {houses.map(house => <option key={house} value={house}>{house}</option>)}
                        </select>
                    </Field>
                    <PhotoPicker
                        label="Fotos (vor der Arbeit)"
                        photos={form.photos}
                        disabled={saving}
                        processing={photoProcessing}
                        onFiles={files => onPhotos(files, "create")}
                        onCamera={() => onOpenCamera("create")}
                        onRemove={index => onRemovePhoto("create", index)}
                        onPreview={onPreview}
                    />
                    <Field>
                        <label htmlFor="todo-comment">Kommentar</label>
                        <textarea id="todo-comment" required value={form.comment} onChange={e => update("comment", e.target.value)} />
                    </Field>
                    <Field>
                        <label htmlFor="todo-author">Von wem?</label>
                        <input id="todo-author" required value={form.author} onChange={e => update("author", e.target.value)} />
                    </Field>
                    <Field>
                        <label htmlFor="todo-date">Datum</label>
                        <input id="todo-date" type="date" required value={form.date} onChange={e => update("date", e.target.value)} />
                    </Field>
                    <ModalButtons>
                        <Button type="button" $secondary disabled={busy} onClick={onClose}>Abbrechen</Button>
                        <Button type="submit" disabled={busy || !form.photos.length}>
                            {saving ? "Speichern..." : "Speichern"}
                        </Button>
                    </ModalButtons>
                </form>
            </Modal>
        </Overlay>
    );
};
export default NewTaskModal;
